export type LanguageCode = 'es-ES' | 'en' | 'ca' | 'fr' | 'it' | 'pt' | 'de';

export interface LanguageInfo {
  code: LanguageCode;
  labelKey: string;
  flag: string;
}

export const SUPPORTED_LANGUAGES: LanguageInfo[] = [
  { code: 'es-ES', labelKey: 'languages.es', flag: '🇪🇸' },
  { code: 'en', labelKey: 'languages.en', flag: '🇬🇧' },
  { code: 'ca', labelKey: 'languages.ca', flag: '🏳️' },
  { code: 'fr', labelKey: 'languages.fr', flag: '🇫🇷' },
  { code: 'it', labelKey: 'languages.it', flag: '🇮🇹' },
  { code: 'pt', labelKey: 'languages.pt', flag: '🇵🇹' },
  { code: 'de', labelKey: 'languages.de', flag: '🇩🇪' },
];
